module.exports = __webpack_public_path__ + "img/ewm.a78c0c59.jpg";